<template>
  <div>
    <vue-headful title="Notificaties" />
    <Header page_title="Notificaties" />
    <div class="">
      <div class="container-fluid px-4 mx-2">
        <form @submit.prevent="onSubmit" class="mb-5 mt-5 ">
          <NotificationContainer />
          <div v-if="user.type == 1">
            <span class="container-fluid sd-title small panel-title">
              <svg-icon icon="person_male" />
              <span class="panel-title-text">Email notificaties</span>
            </span>
            <ul class="panel">
              <li class="panel-item personal-details">
                <div class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                        id="notification_matched"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="form.notification_matched"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label
                        class="custom-control-label"
                        for="notification_matched"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="notification_matched">Stuur e-mail voor alle matches</label>
                  </div>
                </div>
                <div v-if="user.sub_branch === '1'" class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                          id="short_duration_match_notification"
                          type="checkbox"
                          class="custom-control-input"
                          v-model="form.short_duration_match_notification"
                          :true-value="1"
                          :false-value="0"
                      />
                      <label
                          class="custom-control-label"
                          for="short_duration_match_notification"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="short_duration_match_notification">Stuur alleen een e-mail voor matches van 8 weken of korter</label>
                  </div>
                </div>
                <div v-if="user.sub_branch === '1'" class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                          id="long_duration_match_notification"
                          type="checkbox"
                          class="custom-control-input"
                          v-model="form.long_duration_match_notification"
                          :true-value="1"
                          :false-value="0"
                      />
                      <label
                          class="custom-control-label"
                          for="long_duration_match_notification"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="long_duration_match_notification">Stuur alleen een e-mail voor matches van langer dan 8 weken</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="user.type == 1">
            <span class="container-fluid sd-title small panel-title">
              <svg-icon icon="address" />
              <span class="panel-title-text">SMS notificaties</span>
            </span>
            <ul class="panel">
              <li class="panel-item personal-details">
                <div class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                        id="notification_matched_sms"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="form.notification_matched_sms"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label
                        class="custom-control-label"
                        for="notification_matched_sms"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="notification_matched_sms">Stuur sms bij een nieuwe match</label>
                  </div>
                </div>
                <div v-if="user.type == 1  && user.sub_branch === '1'" class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                          id="short_duration_match_sms_notification"
                          type="checkbox"
                          class="custom-control-input"
                          v-model="form.short_duration_match_sms_notification"
                          :true-value="1"
                          :false-value="0"
                      />
                      <label
                          class="custom-control-label"
                          for="short_duration_match_sms_notification"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="short_duration_match_sms_notification">Stuur alleen een sms voor matches van 8 weken of korter</label>
                  </div>
                </div>
                <div v-if="user.type == 1  && user.sub_branch === '1'" class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                          id="long_duration_match_sms_notification"
                          type="checkbox"
                          class="custom-control-input"
                          v-model="form.long_duration_match_sms_notification"
                          :true-value="1"
                          :false-value="0"
                      />
                      <label
                          class="custom-control-label"
                          for="long_duration_match_sms_notification"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="long_duration_match_sms_notification">Stuur alleen een sms voor matches van langer dan 8 weken</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="user.type == 2" class="clearfix">
            <div class="float-left">
              <div class="custom-control custom-switch">
                <input
                  id="notification_applicant"
                  type="checkbox"
                  class="custom-control-input"
                  v-model="form.notification_applicant"
                />
                <label
                  class="custom-control-label"
                  for="notification_applicant"
                ></label>
              </div>
            </div>
            <div class="float-left">
              <label class="toggle-label" for="notification_applicant">Stuur e-mail</label>
            </div>
          </div>
          <template v-if="user.type == 1">
            <span class="container-fluid sd-title small panel-title">
              <svg-icon icon="diploma" />
              <span class="panel-title-text">Nieuwsbrief</span>
            </span>
            <ul class="panel">
              <li class="panel-item personal-details">
                <div class="clearfix">
                  <div class="float-left">
                    <div class="custom-control custom-switch">
                      <input
                        id="notification_newsletter"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="form.notification_newsletter"
                      />
                      <label
                        class="custom-control-label"
                        for="notification_newsletter"
                      ></label>
                    </div>
                  </div>
                  <div class="float-left">
                    <label class="toggle-label" for="notification_newsletter">Inschrijven op nieuwsbrief</label>
                  </div>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="clearfix">
              <div class="float-left">
                <div class="custom-control custom-switch">
                  <input
                      id="notification_newsletter"
                      type="checkbox"
                      class="custom-control-input"
                      v-model="form.notification_newsletter"
                  />
                  <label
                      class="custom-control-label"
                      for="notification_newsletter"
                  ></label>
                </div>
              </div>
              <div class="float-left">
                <label class="toggle-label" for="notification_newsletter">Inschrijven op nieuwsbrief</label>
              </div>
            </div>
          </template>
          <button type="submit" class="btn btn-warning btn-block">Opslaan</button>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: "",
      form: {
        notification_matched: "",
        short_duration_match_notification: "",
        long_duration_match_notification: "",
        notification_matched_sms: "",
        short_duration_match_sms_notification: "",
        long_duration_match_sms_notification: "",
        notification_applicant: "",
        notification_newsletter: ""
      }
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",

    'form.notification_matched'(val) {
      if (this.user.type === 1 && val === 1) {
        this.form.short_duration_match_notification = 0;
        this.form.long_duration_match_notification = 0;
      }
    },
    'form.short_duration_match_notification'(val) {
      if (this.user.type === 1 && val === 1) {
        this.form.notification_matched = 0;
        this.form.long_duration_match_notification = 0;
      }
    },
    'form.long_duration_match_notification'(val) {
      if (this.user.type === 1 && val === 1) {
        this.form.notification_matched = 0;
        this.form.short_duration_match_notification = 0;
      }
    },
    'form.notification_matched_sms'(val) {
      if (this.user.type === 1 && val === 1) {
        this.form.short_duration_match_sms_notification = 0;
        this.form.long_duration_match_sms_notification = 0;
      }
    },
    'form.short_duration_match_sms_notification'(val) {
      if (this.user.type === 1 && val === 1) {
        this.form.notification_matched_sms = 0;
        this.form.long_duration_match_sms_notification = 0;
      }
    },
    'form.long_duration_match_sms_notification'(val) {
      if (this.user.type === 1 && val === 1) {
        this.form.notification_matched_sms = 0;
        this.form.short_duration_match_sms_notification = 0;
      }
    }
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.type == 1) {
        delete this.form["notification_applicant"]; // remove
        this.form.notification_matched = this.user.notification_matched;
        this.form.notification_matched_sms = this.user.notification_matched_sms;
        this.form.short_duration_match_notification = this.user.short_duration_match_notification;
        this.form.long_duration_match_notification = this.user.long_duration_match_notification;
        this.form.short_duration_match_sms_notification = this.user.short_duration_match_sms_notification;
        this.form.long_duration_match_sms_notification = this.user.long_duration_match_sms_notification;

        if (this.form.notification_matched == 1) {
          this.form.short_duration_match_notification = 0;
          this.form.long_duration_match_notification = 0;
        } else if (this.form.short_duration_match_notification == 1) {
          this.form.notification_matched = 0;
          this.form.long_duration_match_notification = 0;
        } else if (this.form.long_duration_match_notification == 1) {
          this.form.notification_matched = 0;
          this.form.short_duration_match_notification = 0;
        }

        if (this.form.notification_matched_sms == 1) {
          this.form.short_duration_match_sms_notification = 0;
          this.form.long_duration_match_sms_notification = 0;
        } else if (this.form.short_duration_match_sms_notification == 1) {
          this.form.notification_matched_sms = 0;
          this.form.long_duration_match_sms_notification = 0;
        } else if (this.form.long_duration_match_sms_notification == 1) {
          this.form.notification_matched_sms = 0;
          this.form.short_duration_match_sms_notification = 0;
        }
      }
      if (this.user.type == 2) {
        delete this.form["notification_matched"]; // remove
        delete this.form["notification_matched_sms"]; // remove
        delete this.form["short_duration_match_notification"];
        delete this.form["long_duration_match_notification"];
        delete this.form["short_duration_match_sms_notification"];
        delete this.form["long_duration_match_sms_notification"];
        this.form.notification_applicant = this.user.notification_applicant;
      }
      this.form.notification_newsletter = this.user.notification_newsletter;
      this.$store.state.loading = false;
    },
    onSubmit() {
      //   save changes
      let formData = new FormData();
      for (var obj in this.form) {
        formData.append(obj, this.form[obj] ? 1 : 0);
      }
      var user_token = JSON.parse(localStorage.getItem("user-token"));
      var url =
        this.$apiURI + (this.user.type == 2 ? "/company" : "/applicant");
      this.$http
        .post(url, formData, {
          headers: {
            Authorization: "Bearer " + user_token,
            Accept: "application/json"
          }
        })
        .then(() => {
          // console.log(success);
          const notification = {
            type: "success",
            message: "Je hebt je gegevens succesvol aangepast. "
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          this.$store.state.loading = false;
          this.updateLocalUser();
        })
        .catch(() => {
          // console.log(error);
          const notification = {
            type: "danger",
            message: "Er is een fout opgetreden.",
              error: true
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          this.$store.state.loading = false;
        });
    }
  }
};
</script>

<style scoped>
  .toggle-label {
      font-size: 14px;
  }

  .sd-title.panel-title {
    display: flex;
    align-items: center;
    margin-top: 40px !important;
    margin-bottom: 20px !important;
    padding: 0 !important;
    line-height: 1;
  }

  .sd-title.panel-title .panel-title-text {
    margin-top: 3px;
    line-height: 1;
  }

  /deep/ .sd-title.panel-title svg {
    margin-right: 20px;
    height: 20px;
    width: 20px;
    color: #FFCD00;
  }

  .panel {
    list-style: none;
    padding: 0 40px;
  }

  .panel .panel-item {
    border-bottom: 1px solid #ececec;
  }

  @media screen and (max-width: 768px) {
    .sd-title.panel-title {
      padding: 0 20px;
    }
  }
</style>
